import { render, staticRenderFns } from "./all-session-rates.vue?vue&type=template&id=65832da2"
import script from "./all-session-rates.vue?vue&type=script&lang=js"
export * from "./all-session-rates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports